import CustomButton from "components/Atoms/CustomButton"
import StyledLink from "components/Atoms/StyledLink"
import { VehicleManagementVehicleDetailsQuery } from "generated/graphql"
import React from "react"
import { useNavigate } from "react-router-dom"
import InfoRow from "../InfoRow"
import ContractTable from "./ContractTable"
interface ContractProps {
  vehicleId?: number | null
  vehicle: any
  contracts?: VehicleManagementVehicleDetailsQuery["vehicleDetails"]["contracts"]
}
const Contract = ({ contracts, vehicle }: ContractProps) => {
  const navigate = useNavigate()
  const curr = vehicle?.currentContract

  return (
    <div>
      <div className="flex justify-between items-baseline">
        <h6 className="m-0">Current Contract</h6>{" "}
        <CustomButton
          onClick={e => {
            navigate(`/d/registration/contract/${curr?.id}`)
          }}
          icon="edit"
          text="Edit Contract"
        />
      </div>
      <hr className="mt-2" />
      <InfoRow
        title="Contract Validity"
        subtitle={
          <span>
            <span className="vt-highlight">{curr?.startDate}</span> to{" "}
            <span className="vt-highlight">{curr?.endDate}</span>
          </span>
        }
      />
      <InfoRow
        className="mb-6"
        title="Contract Number"
        subtitle={
          <StyledLink
            state={vehicle}
            to={{
              pathname: `/d/registration/contract/${curr?.id}`,
            }}
          >
            {curr?.contractCode}
          </StyledLink>
        }
      />
      <ContractTable vehicle={vehicle} contracts={contracts} />
    </div>
  )
}

export default Contract
